import { Button } from '@mui/material';
import moment from 'moment';
import React from 'react';

import './styles.scss';

type TimeFiltersProps = {
  selectedTime: string;
  setSelectedTime: React.Dispatch<React.SetStateAction<string>>;
};

export const filterByTime = (values: any[], selectedTime: string) => {
  const today = moment().startOf('day');

  switch (selectedTime) {
    case 'Yesterday':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isSame(today.clone().subtract(1, 'days'), 'day');
      });
    case 'Last 7 days':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isAfter(today.clone().subtract(7, 'days'));
      });
    case 'Last 15 days':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isAfter(today.clone().subtract(15, 'days'));
      });
    case 'Last 30 days':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isAfter(today.clone().subtract(30, 'days'));
      });
    default:
      return values;
  }
};

export const TimeFilters: React.FC<TimeFiltersProps> = ({ selectedTime, setSelectedTime }) => {
  const timeFilters = ['All', 'Yesterday', 'Last 7 days', 'Last 15 days', 'Last 30 days'];

  return (
    <div className="time-filters">
      {timeFilters.map((filter) => (
        <Button
          key={filter}
          className={`time-filter-button ${selectedTime === filter ? 'active' : ''}`}
          onClick={() => setSelectedTime(filter)}
        >
          {filter}
        </Button>
      ))}
    </div>
  );
};
